import { ExtendedGridLayout } from '../../GridLayoutShell';
import { intermediaryLayoutMap } from './intermediaryLayoutConfig';
import { clientLayoutMap } from './clientLayoutConfig';
import { BreakpointKey } from '../../../../../../../providers/breakpoint/BreakpointProvider';

export function getClientLayoutForBreakpoint(
  breakpoint: BreakpointKey,
  isClientDashboard: boolean = false
): ExtendedGridLayout[] {
  const layoutMap = isClientDashboard ? clientLayoutMap : intermediaryLayoutMap;
  const layout = Object.entries(layoutMap)
    .filter(([_, widgetEntry]) => widgetEntry.layouts[breakpoint])
    .map(([id, widgetEntry]) => {
      const layout = widgetEntry.layouts[breakpoint]!;
      const widgetLayoutConfig: ExtendedGridLayout = {
        i: id,
        x: layout.x,
        y: layout.y,
        w: layout.w,
        h: layout.h,
        widgetProps: widgetEntry.widgetProps,
        chartProps: null,
        tableProps: widgetEntry.tableProps
      };
      return widgetLayoutConfig;
    });

  return layout;
}
